import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Coffee, Phone, Mail, MapPin } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-xl shadow-lg border-b border-orange-200' 
        : 'bg-transparent'
    }`}>
      {/* Top Contact Bar */}
      <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 px-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm font-medium">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span>+94 11 XXX XXXX</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4" />
              <span>exports@claudesspecial.lk</span>
            </div>
            <div className="hidden lg:flex items-center space-x-2">
              <MapPin className="h-4 w-4" />
              <span>Colombo, Sri Lanka</span>
            </div>
          </div>
          <div className="hidden md:block">
            <span className="font-semibold">🇱🇰 Authentic Ceylon Heritage</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/cinnamon-design-4" className="flex items-center space-x-3 group">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                  <Coffee className="h-7 w-7 text-white" />
                </div>
              </div>
              <div>
                <div className={`text-2xl font-bold transition-colors duration-300 ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  Claude's Special
                </div>
                <div className={`text-sm font-medium transition-colors duration-300 ${
                  isScrolled ? 'text-orange-600' : 'text-orange-300'
                }`}>
                  Ceylon Cinnamon Exports
                </div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-2">
              <Link
                to="/cinnamon-design-4"
                className={`px-6 py-3 rounded-lg text-sm font-semibold transition-all duration-300 ${
                  isActive('/cinnamon-design-4') 
                    ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg' 
                    : isScrolled
                      ? 'text-gray-700 hover:bg-orange-100 hover:text-orange-600'
                      : 'text-white hover:bg-white/20 hover:text-orange-300'
                }`}
              >
                Home
              </Link>
              <Link
                to="/ceylon-cinnamon-design-4"
                className={`px-6 py-3 rounded-lg text-sm font-semibold transition-all duration-300 ${
                  isActive('/ceylon-cinnamon-design-4') 
                    ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg' 
                    : isScrolled
                      ? 'text-gray-700 hover:bg-orange-100 hover:text-orange-600'
                      : 'text-white hover:bg-white/20 hover:text-orange-300'
                }`}
              >
                Our Cinnamon
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-700 hover:bg-orange-100' 
                    : 'text-white hover:bg-white/20'
                }`}
              >
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden pb-4">
              <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-xl p-4 space-y-2 border border-orange-200">
                <Link
                  to="/cinnamon-design-4"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 rounded-lg text-base font-semibold transition-colors duration-200 ${
                    isActive('/cinnamon-design-4') 
                      ? 'text-white bg-gradient-to-r from-orange-500 to-red-500' 
                      : 'text-gray-700 hover:text-orange-600 hover:bg-orange-50'
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/ceylon-cinnamon-design-4"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 rounded-lg text-base font-semibold transition-colors duration-200 ${
                    isActive('/ceylon-cinnamon-design-4') 
                      ? 'text-white bg-gradient-to-r from-orange-500 to-red-500' 
                      : 'text-gray-700 hover:text-orange-600 hover:bg-orange-50'
                  }`}
                >
                  Our Cinnamon
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;